<template>
  <section>
    <v-row class="mosaico-coluna-wrapper">
      <v-col
        v-if="dadosPrimeiraColuna.length > 0"
        class="d-flex flex-column pr-3"
        :class="dadosSegundaColuna.length > 0 ? 'align-end' : 'align-center'"
      >
        <div
          v-for="(content, index) in dadosPrimeiraColuna"
          :key="content.id_colaboracao"
          class="card-mosaico fade-animation"
          :style="`animation-duration:${(index + 1) * 200}ms`"
          v-on:click="(e) => selectColab(1, index, e)"
        >
          <CardMosaicoGaleria
            :content="content"
            :card-config="cardsConfig"
            :mosaico-type="0"
            :flg-exibir-uf="flgExibirUf"
            :producao="producao"
          ></CardMosaicoGaleria>
        </div>
      </v-col>
      <v-col
        v-if="dadosSegundaColuna.length > 0"
        class="d-flex flex-column pl-0"
        :class="dadosPrimeiraColuna.length > 0 ? 'align-start' : 'align-center'"
      >
        <div
          v-for="(content, index) in dadosSegundaColuna"
          :key="content.id_colaboracao"
          class="card-mosaico fade-animation"
          :style="`animation-duration:${(index + 1) * 200}ms`"
          v-on:click="(e) => selectColab(2, index, e)"
        >
          <CardMosaicoGaleria
            :content="content"
            :card-config="cardsConfig"
            :mosaico-type="0"
            :flg-exibir-uf="flgExibirUf"
            :producao="producao"
          ></CardMosaicoGaleria>
        </div>
      </v-col>
      <v-col
        v-if="dadosTerceitaColuna.length > 0"
        class="d-flex flex-column pl-0"
        :class="dadosSegundaColuna.length > 0 ? 'align-start' : 'align-center'"
      >
        <div
          v-for="(content, index) in dadosTerceitaColuna"
          :key="content.id_colaboracao"
          class="card-mosaico fade-animation"
          :style="`animation-duration:${(index + 1) * 200}ms`"
          v-on:click="(e) => selectColab(3, index, e)"
        >
          <CardMosaicoGaleria
            :content="content"
            :card-config="cardsConfig"
            :mosaico-type="0"
            :flg-exibir-uf="flgExibirUf"
            :producao="producao"
          ></CardMosaicoGaleria>
        </div>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import CardMosaicoGaleria from "@/components/Cards/CardMosaicoGaleria.vue";
export default {
  components: {
    CardMosaicoGaleria,
  },
  props: {
    colaboracoes: Object,
    cardsConfig: Object,
    flgExibirUf: Boolean,
    producao: Object,
  },
  data() {
    return {
      isCardMosaicoVisible: false,
      dadosPrimeiraColuna: [],
      dadosSegundaColuna: [],
      dadosTerceitaColuna: [],
    };
  },
  created() {
    const { colunaExibicao1, colunaExibicao2, colunaExibicao3 } = this.colaboracoes;
    this.dadosPrimeiraColuna = colunaExibicao1;
    this.dadosSegundaColuna = colunaExibicao2;
    this.dadosTerceitaColuna = colunaExibicao3;
  },
  methods: {
    colaboracaoContemMidia(content) {
      return content.url_midia_thumbnail || content.url_midia_colaboracao;
    },
    selectColab(coluna, index, event) {
      const classes = [...event.target.classList];
      if (!classes.includes("mark-as-read-icon")) {
        this.$emit("onSelectColaboracao", { coluna, index });
      }
    },
  },
  watch: {
    colaboracoes(newValue) {
      const { colunaExibicao1, colunaExibicao2, colunaExibicao3 } = newValue;
      this.dadosPrimeiraColuna = colunaExibicao1;
      this.dadosSegundaColuna = colunaExibicao2;
      this.dadosTerceitaColuna = colunaExibicao3;
    },
  },
};
</script>

<style lang="scss" scoped>
.mosaico-coluna-wrapper {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: center;
}
.card-mosaico {
  margin-bottom: 12px;
}

@keyframes easyIn {
  0% {
    opacity: 0;
    transform: scale(0.1);
  }

  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}

.fade-animation {
  animation-name: easyIn;
}

.col {
  flex-grow: 0;
}
</style>
